import { render } from "./DashboardUserRegisterView.vue?vue&type=template&id=6162611c"
import script from "./DashboardUserRegisterView.vue?vue&type=script&lang=js"
export * from "./DashboardUserRegisterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__